import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const stripHtmlTags = (html) => {
    if (!html) return '';

    return html.replace(/<[^>]+>/g, '');
};

const TruncatedContent = ({ content, maxLength }) => {
    if (!content) return null;

    const plainText = stripHtmlTags(content);
    const truncatedText = plainText.length > maxLength
        ? `${plainText.slice(0, maxLength)}...`
        : plainText;

    return (
        <div dangerouslySetInnerHTML={{ __html: truncatedText }} />
    );
};

TruncatedContent.propTypes = exact({
    content: PropTypes.string.isRequired,
    maxLength: PropTypes.number.isRequired,
});

export default TruncatedContent;
